"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Text_meta_1 = require("../Text.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', Text_meta_1.TEXT_CATEGORY_KEY, Text_meta_1.TEXT_COMPONENT_KEY, ['toggleWrapper']);